import {
    GET_PRESTATIONS_FAIL,
    GET_PRESTATIONS_SUCCESS,
    ADD_PRESTATION_SUCCESS,
    ADD_PRESTATION_FAIL,
    UPDATE_PRESTATION_SUCCESS,
    UPDATE_PRESTATION_FAIL,
    DELETE_PRESTATION_SUCCESS,
    DELETE_PRESTATION_FAIL,
} from "./actionTypes";

const INIT_STATE = {
    prestations: [],
    error: null,
    loading: true
};

const prestationReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        // Récupération des prestations
        case GET_PRESTATIONS_SUCCESS:
            return {
                ...state,
                prestations: action.payload, // tableau d'objets prestation
                loading: false,
                error: null
            };

        case GET_PRESTATIONS_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        // Ajout d'une prestatione
        case ADD_PRESTATION_SUCCESS:
            return {
                ...state,
                prestations: [action.payload, ...state.prestations], // ajoute au début du tableau
                error: null
            };

        case ADD_PRESTATION_FAIL:
            return {
                ...state,
                error: action.payload
            };

        // Mise à jour d'une prestatione
        case UPDATE_PRESTATION_SUCCESS:
            return {
                ...state,
                prestations: state.prestations.map(prestation =>
                    prestation.id.toString() === action.payload.id.toString()
                        ? action.payload // remplace entièrement l'objet prestation
                        : prestation
                ),
                error: null
            };

        case UPDATE_PRESTATION_FAIL:
            return {
                ...state,
                error: action.payload
            };

        // Suppression d'une prestatione
        case DELETE_PRESTATION_SUCCESS:
            return {
                ...state,
                prestations: state.prestations.filter(
                    prestation => prestation.id !== action.payload
                ),
                error: null
            };


        case DELETE_PRESTATION_FAIL:
            return {
                ...state,
                error: action.payload
            };

        default:
            return state;
    }
};

export default prestationReducer;
